'use strict';
module.exports = require('./SplitButton.vue');